import { goToSearchUrl } from '../../helpers/search';

export default function ({ placeholder, mobilePlaceholder }) {
    return {
        placeholder,
        mobilePlaceholder,
        open: false,
        submitDisabled: true,

        init() {
            this.setupWatchers();
            this.setupListeners();
            this.$refs.inputWrapper.classList.remove('hidden');
        },

        close() {
            this.open = false;
            this.activeMobileNavElement = '';
        },

        submitSearch() {
            const query = this.$refs.input.value;

            goToSearchUrl(query);
        },

        getPlaceholder() {
            return this.$store.mq.isMobile()
                ? this.mobilePlaceholder
                : this.placeholder;
        },

        setupWatchers() {
            this.$watch('activeMobileNavElement', () => {
                if (
                    !this.activeMobileNavElement ||
                    this.activeMobileNavElement !== this.navElements.search
                ) {
                    this.open = false;
                    return;
                }

                this.open = !this.open;
            });
        },

        setupListeners() {
            window.addEventListener('search-key-up', () => {
                this.submitDisabled = false;
            });
        }
    };
}
